<af-main-container [customLastBreadcrumb]="organizationId ? null : ('i18n_lib_breadcrumb#UserInfo' | translate :
                   {
                       fullName: [userResponse?.lastName || '', userResponse?.firstName || ''].join(' '),
                       email: userResponse?.email
                   })"
                   [tabPathToTab]="tabPathToTab"
                   [filterNavigationPath]="breadcrumbFilterPath"
                   [breadcrumbCustomizer]="organizationId ? breadcrumbCustomizer : null"
                   [title]="userResponse &&
                   ('i18n_lib_breadcrumb#UserInfo' | translate :
                   {
                       fullName: [userResponse.lastName || '', userResponse.firstName || ''].join(' '),
                       email: userResponse.email
                   })"
                   spinnerIds="initial"
                   [showBackButton]="!!userResponse"
                   [specialFilter]="filterUserIdPath">
    @if (userResponse) {
        <div CustomTitle class="w-100" fxLayout="row" fxLayoutAlign="end center" fxFlex>
            @if (canResendOtp) {
                <ui-kit-button class="mr-16"
                               spinnerId="resendingOtp"
                               (clickListener)="resendOtp()"
                               [label]="'i18n_af_labelResendOtp' | translate"/>
            }
            <ui-kit-svg class="i-24 pointer c-primary-green-800" name="ic_edit" [matTooltip]="'i18n_af_labelEdit' | translate"
                        (click)="editUser()"/>
            @if (!userResponse.isDeleted) {
                <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_delete"
                            [matTooltip]="'i18n_af_labelDeactivate' | translate" (click)="deleteUser()"/>
            } @else {
                <ui-kit-svg class="i-24 pointer ml-16 c-primary-green-800" name="ic_unarchive"
                            [matTooltip]="'i18n_af_labelReactivate' | translate" (click)="reactivate()"/>
            }
        </div>
    }
    @if (userResponse) {
        <div class="container">
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelMainInformation' | translate }}</div>
                <div class="info-container">
                    @for (field of informationFields; track field) {
                        @if (field.showField) {
                            <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field#' + field.filedName | translate }}</div>
                            <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
                        }
                    }
                </div>
            </div>
            <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
                <div class="t2-semi-bold c-main-gray-900">{{ 'i18n_af_labelAccessData' | translate }}</div>
                <div class="info-container">
                    @for (field of accessFields; track field) {
                        <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field#' + field.filedName | translate }}</div>
                        @if (field.filedName === passwordExpiryField) {
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <af-status [status]="passwordExpiryStatus.style" [statusText]="passwordExpiryStatus.text"/>
                            </div>
                        } @else {
                            <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
                        }
                    }
                </div>
            </div>
        </div>
    }
</af-main-container>
